import { motion } from "framer-motion";
import { Check } from "lucide-react";

const HIGHLIGHTS = [
  "100% sprouted whole grains",
  "Traditional wood-fired halwas",
  "Handcrafted micro-batches",
  "Made with Love by Kandulas",
];

export default function Story() {
  return (
    <section id="story" className="grain relative overflow-hidden bg-ragi py-20 sm:py-28 text-cream" data-testid="story-section">
      <div className="pointer-events-none absolute -top-24 right-0 h-96 w-96 rounded-full bg-saffron/10 blur-3xl" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-8 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.22em] text-saffron">Our Story</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight" data-testid="story-title">
            From a mother's kitchen to your table
          </h2>
          <p className="mt-6 text-sm sm:text-base leading-relaxed text-cream/80" data-testid="story-text">
            Kandula Home Foods began in a family kitchen in Tanuku with one simple mission — to
            bring back forgotten Indian millets and honest, unadulterated sweets. Every
            ladle of halwa stirred, every laddu rolled, and every chocolate moulded
            carries the warmth of home-cooked nourishment.
          </p>
          <p className="mt-4 text-sm sm:text-base leading-relaxed text-cream/80">
            We sprout our grains for 48 hours, stone-grind them fresh, and sweeten with
            dates and jaggery wherever we can. No preservatives, no shortcuts — just
            food the way our grandparents made it.
          </p>
          <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-testid="story-highlights">
            {HIGHLIGHTS.map((h) => (
              <li key={h} className="flex items-center gap-3 text-sm text-cream/90">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-saffron/20">
                  <Check className="h-3.5 w-3.5 text-saffron" />
                </span>
                {h}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="overflow-hidden rounded-3xl border-[6px] border-cream/10 shadow-2xl">
            <img
              src="/images/brand/story-cover.webp"
              alt="Kandula home kitchen table with sprouted millets, protein laddus, wheat halwa and jaggery"
              loading="lazy"
              className="h-[380px] sm:h-[480px] w-full object-cover"
              data-testid="story-image"
            />
          </div>
          <div className="absolute -bottom-6 -left-4 sm:-left-8 rounded-2xl bg-terracotta px-6 py-4 shadow-xl">
            <p className="font-display text-3xl font-bold text-white">100%</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/80">home kitchen made</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
